module.exports = __webpack_public_path__ + "assets/img/545fcf47d4c47c611260782f89c7c01c.svg";